export const LOCAL_STORAGE = {
  USER_DETAILS: 'userDetails',
  REMEMBER_ME: 'rememberMe',
  LOGIN_DETAILS: 'loginDetails',
  SEARCH_ITEM: 'searchItem',
};
